import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { saveMasterData } from "./services";
import { useEffect } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getCountry,
  getStates,
} from "../../../PatientCare/Patientregistration/v1/registrationServices";
import moment from "moment";
import { FormOnChangeEventType } from "../../../EMR/types";

const pageTitle = "company ";
function AddOrEditCompany() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  // Fetch all countries and states using react-query
  const { data: countries } = useQuery("countries", getCountry);

  const { mutate: getStateList, data: stateList } = useMutation(getStates);

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    console.log("onSubmit--->", {
      ...value,
      clinicId: Number(user?.clinicId),
      createdById: Number(user?.userId),
      countryId: data?.countryId || 0,
    });
    save([
      {
        clinicId: Number(user?.clinicId),
        companyName: value.companyName,
        companyId: data?.companyId || 0,
        companyAddress: value.address,
        companyWebsite: value.website || null,
        companyEmail: value.email,
        companyFax: value.fax,
        companyLocation: value.location,
        companyMobile: value.mobile,
        countryId: value.country?.id || 0,
        stateId: value.state?.stateId || 0,
        createdById: Number(user?.userId),
        companyPhone: value?.landphone,
        companyContact: value?.contactName,
        companyStatus: value?.status,
        createdDate: moment(new Date()).toISOString(),
      },
    ]);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    if (data) {
      reset({
        address: data?.companyAddress,
        companyName: data?.companyName,
        contactName: data?.companyContact,
        website: data?.companyWebsite,
        email: data?.companyEmail,
        country: { id: data?.countryId, countryName: data?.countryName },
        state: { stateId: data?.stateId, stateName: data?.stateName },
        status: data?.companyStatus,
        fax: data?.companyFax,
        location: data?.companyLocation,
        mobile: data?.companyMobile,
        landphone: data?.companyPhone,
      });
      console.log(data);
      getStateList(data?.countryId);
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="companyName"
              element="input"
              fieldProps={{ label: "Enter company Name" }}
              rules={{ required: "company name is required" }}
            />
            <CustomFormField
              control={control}
              name="contactName"
              element="input"
              fieldProps={{ label: "Enter contact person" }}
              rules={{ required: "company code is required" }}
            />

            <CustomFormField
              control={control}
              name="address"
              element="input"
              fieldProps={{ label: "Enter Address" }}
              rules={{ required: "address is required" }}
            />
            <CustomFormField
              control={control}
              name="website"
              element="input"
              fieldProps={{ label: "Enter website " }}
              rules={{
                required: false,
                pattern: {
                  value: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/)?$/,
                  message: "Enter a valid website domain (e.g. example.com)",
                },
              }}
            />
            <CustomFormField
              control={control}
              name="email"
              element="input"
              fieldProps={{ label: "Enter Email", type: "email" }}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              }}
            />
            <CustomFormField
              control={control}
              name="fax"
              element="input"
              fieldProps={{ label: "Enter fax Number" }}
              rules={{}}
            />
            <CustomFormField
              control={control}
              name="location"
              element="input"
              fieldProps={{ label: "Enter location" }}
              rules={{ required: "location is required" }}
            />
            <CustomFormField
              control={control}
              name="mobile"
              element="input"
              fieldProps={{ label: "Enter Mobile" }}
              rules={{ required: "mobile is required" }}
            />
            <CustomFormField
              control={control}
              name="landphone"
              element="input"
              fieldProps={{ label: "Enter Land Phone" }}
              rules={{}}
            />

            <CustomFormField
              control={control}
              name="country"
              element="autocomplete"
              options={countries?.response ?? []}
              fieldProps={{ label: "country" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => {
                  return option.id == value.id;
                },
                getOptionLabel: (value) => value.countryName,
              }}
              rules={{
                required: "country required",
                onChange: (e: FormOnChangeEventType) =>
                  getStateList(e?.target?.value?.id),
              }}
            />
            <CustomFormField
              control={control}
              name="state"
              element="autocomplete"
              options={stateList?.response ?? []}
              fieldProps={{ label: "state" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => {
                  return option.stateId == value.stateId;
                },
                getOptionLabel: (value) => value.stateName,
              }}
              rules={{ required: "state required" }}
            />

            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditCompany;
